import { Controller, useFormContext } from "react-hook-form";

import { SearchBox } from "src/base-components/SearchBox";
import { ProviderSdkCatalogEntry } from "src/clients/sdk";
import { CreateConnectionGrid } from "src/connections/CreateConnectionGrid";
import { ProviderSelectInputs } from "src/connections/types";

type Props = {
  onSubmit: (data: ProviderSelectInputs) => void;
  onSdkScriptSelect?: (entry: ProviderSdkCatalogEntry) => void;
  searchQuery: string;
  onSearchQueryChange: (searchQuery: string) => void;
};

export const ProviderSelectForm: React.FC<Props> = ({
  onSubmit,
  onSdkScriptSelect,
  searchQuery,
  onSearchQueryChange,
}) => {
  const { control, handleSubmit, setValue } =
    useFormContext<ProviderSelectInputs>();

  return (
    <form
      className="flex h-[min(600px,calc(100vh-200px))] min-h-0 flex-col pt-5 pb-6"
      data-loc="select-provider-form"
      onSubmit={(event) => {
        // Selection is click-only; don't submit on Enter from the search box
        event.preventDefault();
      }}
    >
      <div className="mb-4 shrink-0">
        <SearchBox
          dataLoc="create-connection-provider-search"
          placeholder="Search providers..."
          value={searchQuery}
          onChange={onSearchQueryChange}
        />
      </div>
      <div className="decideScrollbar min-h-0 flex-1 overflow-y-auto pr-1">
        <Controller
          control={control}
          name="provider"
          render={({ field: { onChange } }) => (
            <CreateConnectionGrid
              searchQuery={searchQuery}
              onProviderSelect={(provider, isManifestProvider) => {
                onChange(provider);
                setValue("isManifestProvider", isManifestProvider);
                handleSubmit(onSubmit)();
              }}
              onSdkScriptSelect={onSdkScriptSelect}
            />
          )}
        />
      </div>
    </form>
  );
};
